export default "__VITE_ASSET__BHJ$kbFY__"